module.exports = __webpack_public_path__ + "img/public/siteImages/chatIcon.svg?3d8c3dcb";